import React from "react"
import TypeformEmbed from "../common/TypeformEmbed"

const PrepaidDiscountMedsAndTherapy = () => {
  return <TypeformEmbed id="ZrcLu8Qa" />
}

export default PrepaidDiscountMedsAndTherapy
